import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "groupName" }
const _hoisted_3 = { class: "gameCount" }
const _hoisted_4 = { class: "gamescontainer" }
const _hoisted_5 = {
  key: 0,
  class: "game-slider-container"
}
const _hoisted_6 = {
  key: 1,
  class: "game-slider-container"
}
const _hoisted_7 = { class: "showAllText" }

import { computed, inject, onMounted, ref } from 'vue'
import { PropType } from 'vue'
import GameCard from '../../game/components/gameCard.vue';
import { playClickSound } from '@/utils/media';
import { useRouter } from 'vue-router';
import { GameGroupData, GameList, goToPlayGame } from '@/view/home/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePanel',
  props: {
    gameList: {
        type: Array as PropType<GameList[]>,
        required: true
    },
    groupImage: {
        type: String,
        default: ''
    },
    groupName: {
        type: String,
        default: ''
    },
    itemData: {
        type: Object as PropType<GameGroupData>,
        required: true
    },
    itemIndex: {
        type: Number,
    }

},
  emits: ['showGames', 'goGamePannel'],
  setup(__props, { emit: __emit }) {

const slideDirection = ref<'left' | 'right'>('right')
const gameGrid = ref({
    rowCount: 0,
    columnCount: 0
})
const customStyles = ref({
    active_font_color: '',
    border_color: ""
})
const props = __props
const router = useRouter()
const gameCount = computed(() => props.gameList.length);
const displayCount = computed(() => props.gameList.length < 12 ? props.gameList.length : 12);
const isShowAllGame = ref(false)
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const emits = __emit
const currentPage = ref(0)
const pageSize = computed(() => {
    const size = gameGrid.value.rowCount * gameGrid.value.columnCount
    return size > 0 ? size : 12
})

const totalPages = computed(() => {
    return Math.ceil(props.gameList.length / pageSize.value)
})

const paginatedGameList = computed(() => {
    const start = currentPage.value * pageSize.value
    return props.gameList.slice(start, start + pageSize.value)
})

const pages = computed(() => {
    const list = []
    const size = pageSize.value
    for (let i = 0; i < totalPages.value; i++) {
        const start = i * size
        list.push(props.gameList.slice(start, start + size))
    }
    return list
})


const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        slideDirection.value = 'right'
        currentPage.value++
    }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    if (currentPage.value > 0) {
        playClickSound()
        slideDirection.value = 'left'
        currentPage.value--
    }
}
const GoToPlayGame = (id: any, makerId: any, favorite: number, favId: any) => {
    goToPlayGame(router, openRegisterLoginPopup, id, makerId, favorite, favId)
}
const showGames = () => {
    isShowAllGame.value = !isShowAllGame.value
}
const goToGamePannel = () => {
    emits('goGamePannel')
}
onMounted(() => {
    gameGrid.value.rowCount = props.itemData.gamesGrid.rowCount
    gameGrid.value.columnCount = props.itemData.gamesGrid.columnCount
    customStyles.value.active_font_color = props.itemData.styles.active_font_color
    customStyles.value.border_color = props.itemData.styles.border_color
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["panel_container", { pp_group: props.groupName === 'PP' }]),
    style: _normalizeStyle({ color: customStyles.value.active_font_color })
  }, [
    _createVNode(_component_van_row, {
      class: "titleHead",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "15",
          class: "group_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: props.groupImage,
              alt: ""
            }, null, 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.groupName)), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(gameCount.value), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "8",
          class: "group_col_right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "arrowBtn",
              onClick: prevPage
            }, [
              _createVNode(_component_van_icon, { name: "arrow-left" })
            ]),
            _createElementVNode("div", {
              class: "arrowBtn",
              onClick: nextPage
            }, [
              _createVNode(_component_van_icon, { name: "arrow" })
            ]),
            _createElementVNode("div", {
              class: "gameCount",
              onClick: goToGamePannel
            }, _toDisplayString(_ctx.$t('message.all')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "24",
          class: "beforeContainer"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", null, null, -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      (!isShowAllGame.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "game-track",
              style: _normalizeStyle({ transform: 'translate3d(-' + (currentPage.value * 100) + '%, 0, 0)' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (page, pageIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pageIdx,
                  class: "page-block"
                }, [
                  _createVNode(_component_van_grid, {
                    "column-num": gameGrid.value.columnCount,
                    border: false
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page, (item) => {
                        return (_openBlock(), _createBlock(_component_van_grid_item, {
                          key: item.id,
                          class: "grid-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(GameCard, {
                              gameImage: item.customIcon,
                              gameTypeId: item.id,
                              gameIsFavorite: item.isFavorite,
                              onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id))
                            }, null, 8, ["gameImage", "gameTypeId", "gameIsFavorite", "onClickGameCard"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["column-num"])
                ]))
              }), 128))
            ], 4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createElementBlock("div", {
              class: "page-block",
              key: currentPage.value
            }, [
              _createVNode(_component_van_grid, {
                "column-num": gameGrid.value.columnCount,
                border: false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.gameList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_grid_item, {
                      key: item.id,
                      class: "grid-item"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(GameCard, {
                          gameImage: item.customIcon,
                          gameTypeId: item.id,
                          gameIsFavorite: item.isFavorite,
                          onClickGameCard: ($event: any) => (GoToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id))
                        }, null, 8, ["gameImage", "gameTypeId", "gameIsFavorite", "onClickGameCard"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["column-num"])
            ]))
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1)),
      (!isShowAllGame.value && gameCount.value > 12)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: showGames,
            style: {"padding":"10px"}
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('game.showAll')), 1),
            _createVNode(_component_van_icon, {
              name: "arrow-down",
              class: "showIcon"
            })
          ]))
        : _createCommentVNode("", true),
      (isShowAllGame.value && gameCount.value > 12)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: showGames,
            style: {"padding":"10px"}
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('game.collect')), 1),
            _createVNode(_component_van_icon, {
              name: "arrow-up",
              class: "showIcon"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 6))
}
}

})